import React, { useState } from "react";
import axios from "axios";
import API_BASE_URL from "../../config/api";

const headers = {
  "Content-Type": "application/json",
  // Getter: token czytany przy każdym żądaniu, a nie raz przy ładowaniu skryptu
  // (inaczej po zalogowaniu bez odświeżenia strony wysyłany byłby stary/pusty token).
  get Authorization() {
    return `Bearer ${localStorage.getItem("token")}`;
  },
};

const FileUpload = () => {
  const [file, setFile] = useState();

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axios.post(
        `${API_BASE_URL}/upload`,
        formData,
        {
          responseType: "blob", // Important for handling the binary file download
        },
        { headers },
      );
      // Create a URL for the blob to trigger download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "przefiltrowane_dane_MEDIUM.xlsx"); // or the name you want
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  return (
    <div style={{ maxWidth: "500px", margin: "0", padding: "10px" }}>
      <h2 style={{ textAlign: "left", color: "#333", fontSize: "18px" }}>
        Konwersja Packing list na plik, który zawiera wyłącznie pozycje MEDIUM
      </h2>
      <form
        onSubmit={handleSubmit}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <input
          type="file"
          onChange={handleFileChange}
          style={{
            margin: "10px 0",
            padding: "5px",
            border: "1px solid #ddd",
            borderRadius: "4px",
            fontSize: "14px",
          }}
        />
        <button
          type="submit"
          style={{
            padding: "5px 15px",
            border: "none",
            borderRadius: "4px",
            background: "#007bff",
            color: "#fff",
            cursor: "pointer",
            fontSize: "14px",
          }}
        >
          Prześlij plik
        </button>
      </form>
    </div>
  );
};

export default FileUpload;
